import * as React from 'react';
import cx from 'classnames';
import H5Orientation from '@src/components/h5-orientation';
import styles from './index.less';
import { isFoldableDevice, isFoldableExpanded } from '@src/utils/common-util';
// import deferLoadBetterQuicklink from '@src/utils/defer-load-better-quicklink';

export default class Root extends React.PureComponent {
  mainRef = React.createRef();
  state = {
    initWidth: 0,
    initHeight: 0,
    newWidth: 0,
    newHeight: 0
  };

  componentDidMount() {
    const mainEl = this.mainRef.current;
    mainEl && (mainEl.scrollTop = 0);
    this.setState({
      initWidth: Math.min(document.body.clientWidth, document.body.clientHeight),
      initHeight: Math.max(document.body.clientWidth, document.body.clientHeight),
      newWidth: document.body.clientWidth,
      newHeight: document.body.clientHeight
    });
    window.addEventListener('resize', () => {
      this.setState({
        newWidth: document.body.clientWidth,
        newHeight: document.body.clientHeight
      });
    });
  }

  render() {
    const { className, children } = this.props;
    const { initWidth, initHeight, newWidth, newHeight } = this.state;
    const isFoldable = isFoldableDevice() || isFoldableExpanded(initWidth, initHeight, newWidth, newHeight);
    return (
      <div className={cx(styles.root, className)}>
        {!isFoldable && newWidth > initWidth && <H5Orientation />}
        <div ref={this.mainRef} className={styles.main}>
          {children}
        </div>
      </div>
    );
  }
}
